import React, { useCallback, useState } from 'react';
import config from '@/configs/config';
import { NavLink } from 'react-router-dom';
import { get, isEmpty, map } from 'lodash';
import { makeStyles } from '@material-ui/core';
import Banner from '../containers/Banner';
import CampaignButtons from '../containers/CampaignButtons';
import CampaignDetailModal from './CampaignDetailModal';
import CampaignModalTemplate from './campaignTemplate';
import Filters from '../containers/Filters';
import Legend from '../containers/Legend';
import OfflineCampaigns from '../containers/OfflineCampaigns';
import OnlineSelection from '../containers/OnlineSelection';
import PreOrderSelection from '../containers/PreOrderSelection';
import ProductDetailModal from './productDetailModal/ProductDetailModal';
import TypeSelector from '../containers/TypeSelector';
import basket from '../images/basket.png';
import DateFilter from '../containers/DateFilter';
import DailyMenuPage from '../containers/DailyMenuPage';
import { FILTER } from '../constants';
import Modal from '../../drink/containers/Modal';

const useShoppingCartaButtonStyle = makeStyles(() => ({
  dot: {
    alignItems: 'center',
    background: '#ae0000',
    borderRadius: '50%',
    color: '#ffffff',
    display: 'flex',
    fontSize: 10,
    fontWeight: 'bold',
    height: 15,
    justifyContent: 'center',
    position: 'absolute',
    right: 0,
    top: 0,
    transform: 'translate(50%, -50%)',
    width: 15,
    whiteSpace: 'nowrap',
  },
}));

const ShoppingCartLink = ({ notify }) => {
  const classes = useShoppingCartaButtonStyle();

  if (config.modules?.['daily-fresh-pre-orders'] === false) return null;

  return (
    <NavLink
      to="/menu/shopping-cart"
      className="
        fz-flex
        fz-font-bold
        fz-gap-2
        fz-h-[28px]
        fz-items-center
        fz-ml-auto
        fz-px-2
        fz-relative
        fz-rounded-lg
        md:fz-bg-[#e0e0e0]
      "
    >
      {notify > 0 && (<div className={classes.dot}>{notify}</div>)}
      <img src={basket} height="75%" alt="" />
      <div className="fz-hidden md:fz-block fz-text-[#424242]">
        餐籃
      </div>
    </NavLink>
  );
};

const useStyle = makeStyles((theme) => ({
  root: {},
  bannerContainer: {
    background: '#F4F4F4',
    paddingTop: theme.spacing(2),
  },
  campaignButtonsContainer: {
    background: '#F4F4F4',
    paddingTop: theme.spacing(2),
    width: '100%',
  },
  OfflineCampaignsContainer: {
    background: '#F4F4F4',
    paddingTop: theme.spacing(2),
    width: '100%',
  },
  listContainer: {
    marginTop: theme.spacing(1),
  },
}));

export default ({
  data,
  fridgeOptions,
  onFridgeSelectChange,
  selectedFridgeId,
  shopCampaignDescriptions,
  shoppingCartItemCount = 0,
}) => {
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [productDetailToShow, setProductDetailToShow] = useState({});
  const [selectedCampaign, setSelectedCampaign] = useState({});
  const { template: modalTemplate, data: modalData } = selectedCampaign || {};
  const Cmp = CampaignModalTemplate[modalTemplate];
  const classes = useStyle();
  const selectedFridge = (fridgeOptions || []).find((fridge) => {
    const { id } = fridge || {};
    return id === selectedFridgeId;
  });

  const onProductClick = useCallback((item) => {
    if (isEmpty(item)) return;

    setProductDetailToShow({
      ...item,
      ...get(item, ['filterDict', FILTER.DRINKS], false) && { showDrinkOptions: true },
    });
    setIsProductModalOpen(true);
  }, []);

  const onProductDetailModalClose = () => {
    setIsProductModalOpen(false);
  };

  return (
    <>
      <Modal />
      <div className={`
        ${config.stickyHeader ? 'fz-sticky' : ''}
        fz-top-[60px] fz-bg-white fz-z-10 fz-shadow-md
      `}
      >
        <div className="fz-container fz-m-auto fz-flex fz-h-[50px] fz-items-center fz-px-4 fz-justify-start fz-gap-x-2">
          <span>{`我的${config.BrandNameTW}在`}</span>
          <div className="selected-fridge">
            {(selectedFridge || {}).name || ''}
            <select
              value={selectedFridgeId}
              onChange={(event) => {
                const { value } = event.target;
                onFridgeSelectChange(value);
              }}
            >
              {(fridgeOptions || []).map((fridge) => {
                const { name, id } = fridge || {};
                return (
                  <option key={id} value={id}>
                    {name || ''}
                  </option>
                );
              })}
            </select>
          </div>
          <ShoppingCartLink notify={shoppingCartItemCount || 0} />
        </div>
      </div>
      {isEmpty(shopCampaignDescriptions) ? null : (
        <div className={`
          ${config.stickyHeader ? 'fz-sticky' : ''}
          fz-z-10
          fz-top-[110px]
          fz-bg-primary
          fz-py-1
        `}
        >
          <div className="fz-container fz-text-center fz-m-auto">
            {map(shopCampaignDescriptions, (description) => (
              <div key={description}>
                <div className="fz-text-sm fz-font-bold">{description}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="fz-container fz-m-auto">
        {selectedCampaign && CampaignModalTemplate[modalTemplate] && (
        <CampaignDetailModal onClose={() => { setSelectedCampaign(undefined); }}>
          <Cmp data={modalData} />
        </CampaignDetailModal>
        )}
        <ProductDetailModal
          data={productDetailToShow}
          isOpen={isProductModalOpen}
          onClose={onProductDetailModalClose}
        />
        {get(config, ['modules', 'daily-fresh-pre-orders'], true) ? (
          <PreOrderSelection
            data={data}
            onProductClick={onProductClick}
          />
        ) : null}
        <div className={classes.bannerContainer}>
          <Banner />
        </div>
        {get(config, ['modules', 'menu_campaign_buttons'], true) ? (
          <div className={classes.campaignButtonsContainer}>
            <CampaignButtons />
          </div>
        ) : null}
        <div className={classes.OfflineCampaignsContainer}>
          <OfflineCampaigns onClick={setSelectedCampaign} />
        </div>
        {get(config, ['modules', 'daily-fresh-pre-orders'], true) ? (
          <div className={classes.OfflineCampaignsContainer}>
            <OnlineSelection onClick={onProductClick} data={data} />
          </div>
        ) : null}
        <Filters />
        <DateFilter />
        <TypeSelector />
        <Legend />
        <div className={classes.listContainer}>
          <DailyMenuPage
            data={data}
            onProductClick={onProductClick}
          />
        </div>
      </div>
    </>
  );
};
